import { GetDebitCardAccountsForCardCreation_getDebitCardAccountsV2_accounts as Accounts } from 'types/gql-types/GetDebitCardAccountsForCardCreation'

export const getAccountNameByAccountId = (
  accounts: Accounts[],
  accountId: string
) => accounts.find((account) => account.id === accountId)?.name || ''
